import { ButtonHTMLAttributes, useCallback, useState } from 'react';

import { FileDown, Loader } from 'lucide-react';

import { Button } from './button';

type DownloadButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick' | 'type'> & {
  onDownload?: () => Promise<File | undefined>;
  fileName?: string;
};

export function DownloadButton(props: DownloadButtonProps) {
  const { fileName, onDownload, disabled, className = '', ...rest } = props;
  const [loading, setLoading] = useState(false);

  const handleDownload = useCallback(async () => {
    if (!onDownload) return;
    setLoading(true);

    try {
      const file = await onDownload?.();
      if (file) {
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName ?? 'download';
        a.click();
      }
    } catch (error) {
      console.error('Error downloading file', error);
    }
    setLoading(false);
  }, [onDownload, fileName]);

  return (
    <Button
      {...rest}
      size="icon"
      variant="ghost"
      className={className}
      disabled={loading || disabled}
      onClick={handleDownload}
    >
      {loading ? <Loader className="!size-5 animate-spin " /> : <FileDown className="!size-5 " />}
    </Button>
  );
}
